import { IConfigurationRequest } from "../models/ExtractClient";
import IUserTypeMapping from "../models/misconfig/UsetTypeMapping";
import ISimsUserTypeFieldMappings from "../models/SimsUserTypeFieldMappings";
import BaseService from "./BaseService";
import IAPIResponse from "../models/service/APIResponse";
import { ExtractClientStatus } from "../app/enums";

export default class ConfigurationService extends BaseService {
    controllerName = "establishment";

    async GetExtractClients(establishmentId: any): Promise<any> {
        const resp = await this.Get(`${establishmentId}/extract-clients`, {});
        return resp ? resp.data ?? [] : null;
    }

    async DeleteConfigurations(establishmentId : any, simsConfigurationId: number): Promise<any> {
        const resp = await this.Delete(`${establishmentId}/mis/provider/${simsConfigurationId}`);
        return resp;
    }

    async CreateConfigurations(establishmentId: any, model: IConfigurationRequest): Promise<any> {
        const resp = await this.Post(`${establishmentId}/mis/provider`, {
            misTypeID: model.misTypeID,
            settingsJson: model.settingsJson,
            createFaceTemplates: model.createFaceTemplates,
            arborApplicationID: model.arborApplicationID
        });
        return resp;
    }

    async UpdateConfigurations(establishmentId: any, misConfigurationID: any, model: IConfigurationRequest): Promise<any> {
        const resp = await this.Put(`${establishmentId}/mis/provider/${misConfigurationID}`, {
            misTypeID: model.misTypeID,
            settingsJson: model.settingsJson,
            createFaceTemplates: model.createFaceTemplates,
            arborApplicationID: model.arborApplicationID
        });
        return resp;
    }

    async GetConfigurationsById(establishmentId: any, misConfigurationID: any): Promise<any> {
        const resp = await this.Get(`${establishmentId}/mis/provider/${misConfigurationID}`, {});
        return resp ? resp.data : null;
    }

    async ResetClientSecret(establishmentId: any, clientId: any){
        const resp = await this.Patch(`${establishmentId}/client/${clientId}/reset`, {});
        return resp;
    }

    async GetUserTypes(establishmentId: any, misConfigurationId: any): Promise<any> {
        const resp = await this.Get(`${establishmentId}/mis/provider/${misConfigurationId}/usertypes`, {});
        return resp ? resp.data ?? [] : null;
    }

    async DeleteUserType(establishmentId: any, misConfigurationId: any, userTypeId: any): Promise<any> {
        const resp = await this.Delete(`${establishmentId}/mis/provider/${misConfigurationId}/usertypes/${userTypeId}`);
        return resp.data ? resp.data : resp;
    }

    async CreateUserType(establishmentId: any, misConfigurationId: any, model: IUserTypeMapping): Promise<IAPIResponse<IUserTypeMapping>> {
        const resp = await this.Post(`${establishmentId}/mis/provider/${misConfigurationId}/usertypes`, {
            userTypeID: model.userTypeID,
            isApplicant: model.isApplicant,
            mappingTemplate: Number(model.mappingTemplate),
            providerSettings: model.providerSettings
        });
        return resp;
    }

    async GetUserType(establishmentId: any, configurationId: any, userTypeId: any): Promise<any> {
        const resp = await this.Get(`${establishmentId}/mis/provider/${configurationId}/usertypes/${userTypeId}`, {});     
        return resp ? resp.data : null;
    }

    async UpdateUserType(establishmentId: any, configurationId: any, userTypeId: any, model: IUserTypeMapping): Promise<IAPIResponse<IUserTypeMapping>> {
        const resp = await this.Put(`${establishmentId}/mis/provider/${configurationId}/usertypes/${userTypeId}`, {
            userTypeID: model.userTypeID,
            isApplicant: model.isApplicant,
            mappingTemplate: Number(model.mappingTemplate),
            providerSettings: model.providerSettings
        });
        return resp;
    }

    async GetUserTypeFieldMappings(establishmentId: any, misConfigurationId: any): Promise<any> {
        const resp = await this.Get(`${establishmentId}/mis/provider/${misConfigurationId}/fieldmappings`, {});
        return resp ? resp.data ?? [] : null;
    }

    async UpdateUserTypeFieldMappings(establishmentId: any, misConfigurationId: any, model: ISimsUserTypeFieldMappings): Promise<any> {
        const resp = await this.Patch(`${establishmentId}/mis/provider/${misConfigurationId}/fieldmappings`, model);
        return resp;
    }

    async UpdateExtractClientStatus(establishmentId: any, misConfigurationId: any, status: ExtractClientStatus): Promise<any> {
        // Match API: status via ?status= (enum int). Empty body; avoids body/query ambiguity where `{}` would make body "win".
        const path = `${establishmentId}/mis/provider/${misConfigurationId}/status?status=${encodeURIComponent(String(status))}`;
        const resp = await this.PutWithoutBody(path);
        return resp;
    }

    async SaveCustomFieldConfiguration(establishmentId: string, clientID: string, model: { fieldPaths: string[] }): Promise<IAPIResponse<any>> {

        const resp = await this.Put(`${establishmentId}/client/${clientID}/customfields`,
            {
            fieldPaths: model.fieldPaths
            });
        return resp;
    }

    async GetCustomFieldConfiguration(establishmentId: string, clientID: string): Promise<any> {
        const resp = await this.Get(`${establishmentId}/client/${clientID}/customfields`, {});
        return resp ? resp.data ?? [] : null;
    }
}